import { Controller, Control } from 'react-hook-form';
import { DecomPolicyFormValues } from '../../decom-policy-form-layout.tsx';
import VaultTooltipWithLink, {
  VaultTooltipPreset,
} from './vault-tooltip-with-link.tsx';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface VaultTermsInputProps {
  day: number;
  idx: number;
  control: Control<DecomPolicyFormValues>;
  tooltipPreset: VaultTooltipPreset;
  placeholder: string;
  helperText: string;
}

export default function VaultTermsInput({
  day,
  idx,
  control,
  tooltipPreset,
  placeholder,
  helperText,
}: VaultTermsInputProps) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          Terms (optional)
        </Typography>
        <VaultTooltipWithLink preset={tooltipPreset} sxIcon={{ mb: 0.5 }} />
      </Stack>
      <Controller
        name={`actions.${day}.actions.${idx}.terms`}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value || ''}
            placeholder={placeholder}
            helperText={helperText}
            size="small"
            fullWidth
            variant="standard"
          />
        )}
      />
    </Box>
  );
}
